import React, { FC, useMemo } from 'react';

import { IconButton } from '@mui/material';

import { ReactComponent as GoogleIcon } from 'assets/icons/google.svg';
import { StyledCellText2 } from 'molecules/Table/styles/Text.styles';
import { StyledCellContainer } from 'molecules/Table/styles';
import Table from 'molecules/Table';
import { ICompanyGoogler } from '.';

const CompanyGooglers: FC<{
  company_hs_id: string;
  users: ICompanyGoogler[];
}> = ({ company_hs_id, users }) => {
  const columns = useMemo(
    () => [
      {
        key: 'name',
        label: 'Name',
        sortable: false,
        width: '20%',
        render: ({ name }: ICompanyGoogler) => (
          <StyledCellText2>{name}</StyledCellText2>
        ),
      },
      {
        key: 'id',
        label: 'Email',
        sortable: false,
        render: ({ id }: ICompanyGoogler) => (
          <StyledCellText2>{id}</StyledCellText2>
        ),
      },
      {
        key: 'company_level_googler',
        label: '',
        sortable: false,
        width: '50%',
        render: ({ company_level_googler }: ICompanyGoogler) => (
          <StyledCellContainer $right $hStack $size="small">
            {company_level_googler && (
              <IconButton disabled>
                <GoogleIcon width="16px" height="16px" color="#D96865" />
              </IconButton>
            )}
          </StyledCellContainer>
        ),
      },
    ],
    [company_hs_id]
  );

  return (
    <Table
      data={users}
      columns={columns}
      idKey="id"
      sx={{ minWidth: 650 }}
      aria-label="simple table"
      size="small"
    />
  );
};

export default CompanyGooglers;
